'use strict';

var dialog = require('_core_ext/dialog'),
    minicart = require('_core_ext/minicart'),
    page = require('_core_ext/page'),
    carousel = require('_core_ext/carousel'),
    cart = require('../cart'),
    util = require('_core_ext/util'),
    Promise = require('promise'),
    _ = require('lodash');

import eventMgr from '_core_ext/core/eventMgr';
import ajax from '_core_ext/ajax';
import layout from '_core_ext/layout';
import progress from '_core/progress';

let $cache = {},
    selectors = {
        addToCart: '.add-to-cart',
        addAllToCart: '#add-all-to-cart',
        selectAllOptions: '.select-all-options',
        addToCartDisabled: '.add-to-cart[disabled]',
        selectAllOptionsSticky: '.js-select-all-options',
        productVariations: '.js-product-variations',
        productVariationsLabelError: '.c-product-variations__labelError',
        pdpMainAddToBagCTA: '.js-pdp-main-add-to-bag'
    };

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form, triggerOnlyRemove) {
    var $form = $(form),
        $qty = $form.find('input[name="Quantity"]'),
        $triggerOnlyRemove = triggerOnlyRemove || false;
    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val('1');
    }
    if(window.sessionStorage.productPosition){
        $form.find('#productPosition').val(window.sessionStorage.productPosition);
    }
    if(window.sessionStorage.actionFieldList){
        $form.find('#productList').val(window.sessionStorage.actionFieldList);
    }
    if(window.sessionStorage.gridViewType){
        $form.find('#viewType').val(window.sessionStorage.gridViewType);
    }
    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then((response) => {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        } else {
            if(!$triggerOnlyRemove){
                $cache.document.trigger('product.addedToCart', [$form], $qty.val());
            }
            return response;
        }
    });
};

var addItemToCartQuickShop = function (params) {
    var {pid, cartAction, cid, productPosition, loaderLocation, showMiniCart} = params;
    var productList = '';
    var recommendationsCarouselData = $(loaderLocation).parents('.recommendations-carousel');
    var recommendationsCarouselTitle = recommendationsCarouselData.data("display-title");
    var recentlyViewedDiv = $(loaderLocation).parents('.recently-viewed-carousel');
    var actionFieldList = $(loaderLocation).parents('.js-product-impression').data('productDetails').list;
    var selectedView = $('.js-cmp-gridView');
    var viewType = 'not apply';     
    if(selectedView.data('cmp') == 'gridView'){
        viewType = selectedView.data('json-config').preSelectedViewMode;
    }
    if (recentlyViewedDiv.length > 0) {
        productList = recentlyViewedDiv.find('.recently-viewed-carousel__title')[0].innerHTML;
    } else if(recommendationsCarouselData.length > 0 && recommendationsCarouselTitle !== undefined) {
        productList = recommendationsCarouselData.data("display-title");
        let gridTile = $(loaderLocation).parents('.grid-tile');
        productPosition = recommendationsCarouselData.find('.grid-tile').index(gridTile) + 1;
    } else if(pageContext && pageContext.type && (pageContext.type.toUpperCase() === 'search'.toUpperCase())) {
        productList = 'Search';
    } else {
        productList = actionFieldList;
    }
    progress.show(loaderLocation);
    return new Promise((res, rej) => {
        var url = util.appendParamsToUrl(Urls.addProduct, {pid: pid, cartAction: cartAction, cid:cid, productPosition:productPosition, productList:productList, viewType:viewType});
        ajax({
            type: 'POST',
            url: url,
            contentType: 'text/html',
            callback: (response) => {
                progress.hide();
                if (response.error) {
                    return rej(response.error);
                }
                $(".js-toast-container").html(response);
                let top = $(".header").height();
                $(".js-toast-container").find('#add-to-cart-toast').css('top', top);
                $(".js-toast-container").find('#add-to-cart-toast').addClass('show-toast');
                if (window.pageContext && $('#add-to-cart-toast').data('context')) {
                    let context = $('#add-to-cart-toast').data('context');
                    window.pageContext.analytics.basket = context.analytics && context.analytics.basket ? context.analytics.basket : '';
                }
                let url = util.appendParamsToUrl(Urls.updateProductQuantity, {
                    uuid: $('#prd-toast-uuid').val(),
                    pid: $('#prd-toast-pid').val(),
                    Quantity: $('#prd-toast-qty').val()
                });
                cart.updateCart(url, false, false);
                setTimeout(function() {
                    $(".js-toast-container").find('#add-to-cart-toast').removeClass('show-toast');
                    $('.mini-cart-total').removeClass('inactive');
                }, 5000);
                $(document).on('click', '.icon-close', function() {
                    $(".js-toast-container").find('#add-to-cart-toast').removeClass('show-toast');
                });
                res();
            }
        });
    });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');

    if($(this).parents('.js-edit-cart').length > 0) {
        window.sessionStorage.gridViewType = 'not apply';
        var prodID = $(this).parents('.js-edit-cart').find('.c-product-details__name').text().trim();
        var $lineItem;
        var $currQty;
        var $triggerOnlyRemove;
        if($(this).parents('.product-edit-modal').hasClass('cartTriggered')) {
            $lineItem = $('.c-products-table').find('.c-products-item__name a:contains("'+prodID+'")').parents('.c-products-table__item');
            window.sessionStorage.actionFieldList = 'cart';
            $currQty = parseInt($('.c-products-table').find('.c-products-item__name a:contains("'+prodID+'")').parents('.c-products-table__item').find('.js-item-quantity-field').val());
        } else {
            $lineItem = $('.c-mini-cart__products-container, .c-checkout-minicart__list').find('.c-mini-cart__product-item-name a:contains("'+prodID+'")').parents('.c-mini-cart__product-item-row');
            if($lineItem.parent('.c-checkout-minicart__list').length > 0) {
                window.sessionStorage.actionFieldList = 'ordersummary';
            } else {
                window.sessionStorage.actionFieldList = 'minibag';
            }

            $currQty = parseInt($lineItem.find('.c-mini-cart-qty').text().trim());
        }
        window.sessionStorage.productPosition = $(this).parents('.js-edit-cart').attr('data-trigger-pos');

        var $updatedQty = parseInt($(this).parents('.js-edit-cart').find('.js-item-quantity-field').val() || $(this).parents('.js-edit-cart').find('#quantity').val());
        if($(this).parents('.js-edit-cart').attr('data-variation-changed') === 'true' && $updatedQty === $currQty) {
            $cache.document.trigger('product.removeFromCart', [$lineItem, $currQty]);
            addItemToCartHandler($form);
            return;
        } else if($(this).parents('.js-edit-cart').attr('data-variation-changed') === 'true' && $updatedQty != $currQty) {
            $cache.document.trigger('product.removeFromCart', [$lineItem, $currQty]);
            if($updatedQty > $currQty) {
                addItemToCartHandler($form);
            } else if($updatedQty < $currQty) {
                    //$triggerOnlyRemove = true;
                    addItemToCartHandler($form, $triggerOnlyRemove);
            }
        } else if($(this).parents('.js-edit-cart').attr('data-variation-changed') === 'false' && $updatedQty === $currQty) {
            page.refresh();
        } else if($(this).parents('.js-edit-cart').attr('data-variation-changed') === 'false' && $updatedQty != $currQty) {
            if($updatedQty > $currQty) {
                addItemToCartHandler($form);
            } else if($updatedQty < $currQty) {
                $cache.document.trigger('product.removeFromCart', [$lineItem, $currQty - $updatedQty]);
                $triggerOnlyRemove = true;
                addItemToCartHandler($form, $triggerOnlyRemove);
                
            }
        }
    } else {
        addItemToCartHandler($form);
    }
};

/**
 * @description add item to cart handler
 */
function addItemToCartHandler($form, $triggerOnlyRemove) {
    addItemToCart($form, $triggerOnlyRemove).then((response) => {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            let url = util.appendParamsToUrl(Urls.updateProductQuantity, {
                uuid: $($uuid[0]).val(),
                pid: $form.find('input[name="pid"]').val(),
                Quantity: $form.find('input[name="Quantity"]').val(),
                position: $form.find('input[name="productPosition"]').val(),
                list: $form.find('input[name="productList"]').val(),
                cgid: $form.find('input[name="cid"]').val()
            });
            cart.updateCart(url, false, false);
            setTimeout(function() {
                page.refresh();
            }, 400);
        } else {
            // minicart.show(response);
            if ($('.quick-shop-modal').length) {
                $('.quick-shop-modal .quickshop-modal-content').replaceWith(response);
                $('.quick-shop-modal #add-to-cart-toast').addClass('show-toast');
                $('.quick-shop-modal .proceed-btns a').each(function () {
                    $(this).text("Go to " + $(this).text());
                });
                setTimeout(function() {
                    $(".js-toast-container").find('#add-to-cart-toast').removeClass('show-toast');
                    $('.quick-shop-modal').remove();
                }, 5000);
            } else {
                $(".js-toast-container").html(response);
                if (window.pageContext && $('#add-to-cart-toast').data('context')) {
                    let context = $('#add-to-cart-toast').data('context');
                    window.pageContext.analytics.basket = context.analytics && context.analytics.basket ? context.analytics.basket : '';
                }
                let top = $(".header").height();
                $(".js-toast-container").find('#add-to-cart-toast').css('top', top);
                $(".js-toast-container").find('#add-to-cart-toast').addClass('show-toast');
                let originalText = $.trim($(selectors.addToCart).text());
                let addedText = $(selectors.addToCart).data('addedtobag');
                $(selectors.addToCart).text(addedText);
                let url = util.appendParamsToUrl(Urls.updateProductQuantity, {
                    uuid: $('#prd-toast-uuid').val(),
                    pid: $('#prd-toast-pid').val(),
                    Quantity: $('#prd-toast-qty').val()
                });
                cart.updateCart(url, false, false);
                setTimeout(function() {
                    $(selectors.addToCart).text(originalText);
                    $(".js-toast-container").find('#add-to-cart-toast').removeClass('show-toast');
                }, 5000);
                $(document).on('click', '.icon-close', function() {
                    $(".js-toast-container").find('#add-to-cart-toast').removeClass('show-toast');
                });
            }
        }
    });
}

/**
 * @description Handler to handle hover event of add to cart button
 */
var addToCartHover = function () {
    var button = $(this),
        originalText = $.trim(button.text()),
        hoverText = button.data('hover-text');

    button.data('hover-text', originalText);
    button.text(hoverText);
    button.toggleClass('active');
};

/**
 * @description select all options sticky handler
 */
function selectAllOptionsSticky() {
    $('html, body').animate({
        scrollTop: $(selectors.productVariations).offset().top - (window.innerHeight / 2)
    }, 600);
}

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
    e.preventDefault();
    var $productForms = $('#product-set-list').find('form').toArray();
    Promise.all(_.map($productForms, addItemToCart))
        .then((responses) => {
            dialog.close();
            // show the final response only, which would include all the other items
            minicart.show(responses[responses.length - 1]);
        });
};

/**
 * @description Add find your match products in jeans-fit-guide-woman page.
 */
var addFindYourMatchProducts = function (e) {
    var $this;
    if(e.currentTarget) {
        $this = $(e.currentTarget);
    } else {
        $this = $('.token-anchor:visible').first();
    }
        var catId = $this.attr('href'),
        url = $this.attr('action-url');
    var $findYourMatchDiv = $(catId).find('.find-your-match');
    url = util.appendParamToURL(url, 'format', 'ajax');
    if(!$findYourMatchDiv.find('.c-product-list').length) {
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'html',
            success: function(response) {
                $findYourMatchDiv.html(response);
                setTimeout(function() {
                    $(document).trigger('init.all.carousels.insideselector', $findYourMatchDiv);
                }, 500);
            },
            error: function() {
                
            }
        });
    }
}

/**
 * @function
 * @description show desktop Variation Error Label
 */
function showDesktopVariationLabelError() {
    $(selectors.productVariationsLabelError).show();
    var fullHeaderLayoutHeight = $('#header').outerHeight();
    if (layout.isMobileView()) {
          $( 'html, body' ).animate({
            scrollTop: $( '.c-product-variations' ).offset().top - fullHeaderLayoutHeight - 10
            }, '300' );
    }
}

/**
 * @function
 * @description initialize cache
 */
function initializeCache() {
    $cache.document = $(document);
}

/**
 * @function
 * @description initialize fit guide functionality
 */
function initializeFitguide() {
    if($('#fitguide-woman').length) {
        var $firstCat = $('.token-anchor:visible').first();
        addFindYourMatchProducts($firstCat);
    }
}

/**
 * @function
 * @description initialize events
 */
function initializeEvents() {
    $cache.document.find(selectors.addToCartDisabled).attr('title', $('.availability-msg').text());
    $cache.document.off('click', selectors.addToCart, addToCart).on('click', selectors.addToCart, addToCart);
    $cache.document.on('mouseenter mouseleave', selectors.selectAllOptions, addToCartHover);
    $cache.document.on('click', selectors.selectAllOptionsSticky, selectAllOptionsSticky);
    $cache.document.on('click', selectors.addAllToCart, addAllToCart);
    eventMgr.registerAction('addToCart.quick.shop', addItemToCartQuickShop);
    $cache.document.on('click', selectors.pdpMainAddToBagCTA, showDesktopVariationLabelError);
    $cache.document.on('click', '.token-anchor', addFindYourMatchProducts);
    initializeFitguide();
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
function init() {
    initializeCache();
    initializeEvents();
}

module.exports = {
    init: function (params) {
        init(params);
    }
};
